import { SHIPFRAUD } from "../../actions/portal/";

export default function(state = [0, 0], action) {
  switch (action.type) {
    case SHIPFRAUD:
      return action.payload;
    default:
  }
  return state;
}
